
console.warn('DataTables Editor temporary holding file.');
console.info('If you are seeing this message, it is because Editor has been');
console.info('installed using `npm install datatables.net-editor`, but the');
console.info('licensed or trial files have not been installed in place of');
console.info('the holding files.');
console.info('');
console.info('To install the files, please download Editor from');
console.info('https://editor.datatables.net and replace the Javascript and');
console.info('CSS files in `node_modules/datatables.net-editor` with those');
console.info('from the downloaded package. `install.sh` can be used to');
console.info('install the files from the downloaded zip.');

export default {};
